"use strict";

module.exports = {
  productInfo: function () {
    if ($(window).width() > 840) {
      var $sizesContainer = $(".select-all-size .sizes-container");
      var $toggleButton = $("#toggle-sizes");

      // Vérifier le nombre d'éléments
      if ($sizesContainer.length <= 8) {
        $toggleButton.addClass("d-none");
      } else {
        $toggleButton.removeClass("d-none").addClass("d-block");
      }

      // Créer un conteneur pour les éléments restants
      var $extraContainer = $('<div class="select-all-size"></div>');
      $sizesContainer.slice(8).appendTo($extraContainer); // Déplacer les éléments dans la nouvelle div

      // Insérer le conteneur avant le bouton
      $extraContainer.insertBefore($toggleButton);
      $extraContainer.hide(); // Masquer par défaut

      var isExpanded = false;

      // Obtenir les textes des boutons
      var $buttonShowMore = $toggleButton.data("show-more");
      var $buttonShowLess = $toggleButton.data("show-less");

      // Gérer le clic sur le bouton
      $toggleButton.on("click", function () {
        if (!isExpanded) {
          $extraContainer.stop(true, true).slideDown(300); // Afficher tous les éléments restants
          $(this).text($buttonShowLess);
        } else {
          $extraContainer.stop(true, true).slideUp(300); // Cacher tous les éléments restants
          $(this).text($buttonShowMore);
        }
        isExpanded = !isExpanded;
      });

      var heightProduct = $(
        ".product-view-carousel .carousel-inner"
      ).outerHeight();
      $(".product-view-carousel .carousel-indicators").css({
        "max-height": heightProduct,
        "overflow-y": "scroll",
      });

      $(".product-view-carousel .carousel-indicators").css({
        "-ms-overflow-style": "none",
        "scrollbar-width": "none",
      });

      $(".product-view-carousel .carousel-indicators::-webkit-scrollbar").css({
        display: "none",
      });
    }

    function toggleCarouselArrows() {
      var $carousel = $(".product-view-carousel");
      var itemCarousel = $carousel.find(".carousel-item");
      var $indicators = $carousel.find(".carousel-indicators li");
      var $prevArrow = $carousel.find(".carousel-control-prev");
      var $nextArrow = $carousel.find(".carousel-control-next");

      if (itemCarousel.length == 1) {
        $prevArrow.removeClass("d-flex").addClass("arrow-disabled");
        $nextArrow.removeClass("d-flex").addClass("arrow-disabled");
      } else {
        $prevArrow.removeClass("arrow-disabled").addClass("d-flex");
        $nextArrow.removeClass("arrow-disabled").addClass("d-flex");

        if ($indicators.first().hasClass("active")) {
          $prevArrow.removeClass("d-flex").addClass("arrow-disabled");
        } else {
          $prevArrow.removeClass("arrow-disabled").addClass("d-flex");
        }

        if ($indicators.last().hasClass("active")) {
          $nextArrow.removeClass("d-flex").addClass("arrow-disabled");
        } else {
          $nextArrow.removeClass("arrow-disabled").addClass("d-flex");
        }
      }
    }

    toggleCarouselArrows();

    $(".carousel-product-arrows-zoom a").on("click", function () {
      setTimeout(toggleCarouselArrows, 500);
    });

    $(".carousel-indicators li").on("click", function () {
      setTimeout(toggleCarouselArrows, 500);
    });

    var selectedColor = $(".color-attribute.selected").data("color-selected");
    $(".label-size .color-selected").empty().text(selectedColor);
    $(".label-size .selected-label").removeClass("d-none");

    $(document).on("click", ".color-attribute", function () {
      var selectedColor = $(this).data("color-selected");

      $(".label-size .color-selected").empty().text(selectedColor);

      $(".label-size .selected-label").removeClass("d-none");

      $(".color-attribute").removeClass("selected").prop("disabled", false);
      $(this).addClass("selected").prop("disabled", true);
    });

    $(".color-attribute").prop("disabled", false);
    $(".color-attribute.selected").prop("disabled", true);

    var viewSize = $(window).width();
    if(viewSize > 769) {
      var heightOfHeader = $('header').outerHeight();
      var heightbreadCrumb = $('.breadcrumb').outerHeight();
      var $firstChildBlock = $('.tec-detail .first-part-scrolling-pdp');
  
      $firstChildBlock.css('top',(heightOfHeader + heightbreadCrumb) + 'px');
  
      var $childBlock = $('.tec-detail .second-part-scrolling-pdp');
      var childHeight = $childBlock.outerHeight(true);
    }

    if ($('.size-unselectable.size-field').length > 0 ) {
      $('.show-back-in-stock').addClass('d-lg-block').removeClass('d-none');
    } else {
      $('.show-back-in-stock').addClass('d-none').removeClass('d-lg-block');
    }
  }
};

// Appeler la fonction directement
module.exports.productInfo();
